export const autopayConst = {
    due: "DUE DATE",
    payFrom: "Pay From",
    amount: "AMOUNT",
}